// Getters
const $getHeroCards = () => document.querySelectorAll(".js-hero-card");
const $getDtfSource = $container =>
  $container.querySelector(".js-hero-badge-default [data-delivery-for]") ||
  $container.querySelector("[data-delivery-for]") ||
  $container.querySelector(".js-hero-dtf-date-source");
const $getBadgeNew = $container => $container.querySelector(".js-hero-badge-dtf");
const $getBadgeDefault = $container => $container.querySelector(".js-hero-badge-default");
const $getWord = $container => $container.querySelector(".js-hero-dtf-word");
const $getRest = $container => $container.querySelector(".js-hero-dtf-rest");

// Actions
function applyDtfBadgeState($container) {
  const $source = $getDtfSource($container);
  const $badgeNew = $getBadgeNew($container);
  const $badgeDefault = $getBadgeDefault($container);
  if (!$source || !$badgeNew || !$badgeDefault) return;

  const text = ($source.textContent || "").trim();
  if (!text) return;

  const lower = text.toLowerCase();
  const isSameOrNext = lower.startsWith("today") || lower.startsWith("tomorrow");

  if (isSameOrNext) {
    const primary = lower.startsWith("today") ? "Today" : "Tomorrow";
    const $word = $getWord($container);
    const $rest = $getRest($container);
    if ($word) $word.textContent = primary;
    if ($rest) $rest.textContent = "";

    $badgeNew.classList.remove("hidden");
    $badgeDefault.classList.add("hidden");
  } else {
    $badgeNew.classList.add("hidden");
    $badgeDefault.classList.remove("hidden");
  }
}

function initHeroCards() {
  const $cards = $getHeroCards();
  $cards.forEach($card => {
    // Only act on DTF cards that have the special badge
    const $hasDtfBadge = $getBadgeNew($card);
    if (!$hasDtfBadge) return;

    const $dtfSource = $getDtfSource($card);
    if (!$dtfSource) return;

    // Initial apply in case the date is already filled
    applyDtfBadgeState($card);

    // Observe future changes coming from DeliveryDateClass
    const observer = new MutationObserver(() => {
      applyDtfBadgeState($card);
    });
    observer.observe($dtfSource, {
      characterData: true,
      subtree: true,
      childList: true,
      attributes: true
    });
  });
}

export default function initHeroCard() {
  if (window.jiffyHeroDtfBadgeInitialized) return;
  window.jiffyHeroDtfBadgeInitialized = true;
  initHeroCards();
}
